import { StatusTag } from "src/components/DataDisplay/StatusTag";
import {
  FORM_SCHOOL_RANK_SUB_STATUS,
  FormSchoolRankSubStatusIndex,
} from "src/constants";
import { calculateOfferRemainingTime } from "src/services/form/offer";
import * as GQL from "src/types/graphql";

export type Waitlist = {
  readonly status: GQL.waitlist_status_enum;
  readonly waitlist_position: { readonly position: number | null } | null;
};
export type Offer = {
  readonly status: GQL.offer_status_enum;
  readonly expires_at?: string | null;
};
interface SubStatusTagProps {
  formSchoolRankSubStatus: FormSchoolRankSubStatusIndex;
  waitlist: Waitlist | null;
  offer: Offer | null;
  showWaitlistPosition: boolean;
  timezoneName: string;
  isActionPending?: boolean;
}

export function SubStatusTag({
  formSchoolRankSubStatus,
  waitlist,
  offer,
  showWaitlistPosition,
  timezoneName,
  isActionPending = false,
}: SubStatusTagProps) {
  const status = FORM_SCHOOL_RANK_SUB_STATUS[formSchoolRankSubStatus];
  const waitlistPosition = waitlist?.waitlist_position?.position;
  let substatusLabel = status.label;

  if (offer && offer.expires_at) {
    const expiration = calculateOfferRemainingTime({
      expires_at: offer.expires_at,
      timezone_name: timezoneName,
    });
    substatusLabel = `${status.label}, ${expiration}d left`;
  } else if (
    waitlist?.status === GQL.waitlist_status_enum.Waitlisted &&
    waitlistPosition
  ) {
    substatusLabel = `${GQL.waitlist_status_enum.Waitlisted}${
      showWaitlistPosition ? `, #${waitlistPosition}` : ""
    }`;
  }

  return (
    <StatusTag
      customLabel={substatusLabel}
      isLoading={isActionPending}
      status={status}
    />
  );
}
